import { IconShoppingCart } from '@tabler/icons-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import Badge from '@/components/ui/badge';
import { buttonVariants } from '@/components/ui/button';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import { CartList } from '@/features/cart/components/cart-list';
import { useUserCart } from '@/features/cart/hooks/use-user-cart';
import { cn } from '@/lib/cn';
export const CartMenu = () => {
  const [isOpen, setOpen] = useState(false);
  const pathname = usePathname();
  const {
    data
  } = useUserCart();
  const cartLength = data?.cartItems.length || 0;
  const isActive = pathname === '/cart';
  return <HoverCard openDelay={200} open={isOpen && cartLength !== 0} onOpenChange={value => setOpen(value)} data-sentry-element="HoverCard" data-sentry-component="CartMenu" data-sentry-source-file="cart-menu.tsx">
      <HoverCardTrigger asChild className="mr-2.5 relative" data-sentry-element="HoverCardTrigger" data-sentry-source-file="cart-menu.tsx">
        <div>
          <Link href={'/cart'} data-sentry-element="Link" data-sentry-source-file="cart-menu.tsx">
            <IconShoppingCart stroke={1.5} className={cn('w-7 h-7', {
            'text-primary': isActive
          })} data-sentry-element="IconShoppingCart" data-sentry-source-file="cart-menu.tsx" />
            {cartLength > 0 && <div className="absolute -top-2.5 -right-2.5">
                <Badge body={cartLength} />
              </div>}
          </Link>
          <span className="sr-only">items in cart, view cart</span>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="bg-background mt-4 -mr-4 w-96 p-0" align="end" data-sentry-element="HoverCardContent" data-sentry-source-file="cart-menu.tsx">
        <div className="h-96 text-foreground">
          <div className="mx-auto px-4 py-3">
            <div className="flex items-center gap-1">
              <p className="text-2xl font-bold">Cart</p>
              <span className="mt-1 text-gray-600">
                ({cartLength} {cartLength === 1 ? 'item' : 'items'})
              </span>
            </div>
          </div>
          <div className="max-h-80 overflow-auto">
            <CartList data-sentry-element="CartList" data-sentry-source-file="cart-menu.tsx" />
          </div>
          <div className="border-t bg-gray-100 p-4">
            <Link href="/cart" className={buttonVariants({
            variant: 'outline',
            className: 'w-full'
          })} data-sentry-element="Link" data-sentry-source-file="cart-menu.tsx">
              View cart
            </Link>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>;
};